class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#productSearch_results");
    this.suggestion = document.getElementById("suggestion");
    const enterKey = 13;
    const rightarrow = 39;
    const leftarrow = 37;
    const uparrow = 38;
    const downarrow = 40;
    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
    this.input.addEventListener("keydown", (e) => {
      if (
        (e.keyCode == rightarrow ||
          e.keyCode == leftarrow ||
          e.keyCode == uparrow ||
          e.keyCode == downarrow) &&
        this.suggestion.innerText != ""
      ) {
        e.preventDefault();
        this.input.value = suggestion.innerText;
        this.getSearchResults(this.input.value);
      }
      // if (e.keyCode == enterKey) {
      //   e.preventDefault();
      //   this.suggestion.innerHTML = "";
      //   this.getSearchResults(this.input.value);
      // }
    });
    this.input.addEventListener("touchend", (e) => {
      this.input.value = suggestion.innerText;
      this.getSearchResults(this.input.value);
    });
  }

  clearSuggestion() {
    this.suggestion.innerHTML = "";
    $("#predictive-search").html("");
  }
  
  onChange() {
    const searchTerm = this.input.value.trim();
    this.clearSuggestion();
    if (!searchTerm.length) {
      this.close();
      this.clearSuggestion();
      $(".productSearch_results").hide(); 
      $(".menuSearch_suggestions").show(); 
      return;
    }
    this.inlinepredictivesearchresult(searchTerm);
    this.getSearchResults(searchTerm);
  }

  inlinepredictivesearchresult(searchTerm) {
    fetch(
      `/search/suggest.json?q=${searchTerm}&resources[type]=product&resources[limit]=10&resources[limit_scope]=each`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        var obj = jQuery.parseJSON(text);
        var queries = obj.resources.results.products;
        var producttitlelist = [];
        if (queries.length > 0) {
          $.each(queries, function (i, data) {
            if (
              data.title.indexOf("Exclusive") === -1 &&
              data.title.indexOf("Fee") === -1 &&
              data.title.indexOf("Special") === -1 &&
              data.handle.endsWith("-byob") === false &&
              data.tags.indexOf("hide_addtocart") === -1 &&
              data.tags.indexOf("hide_product") === -1
            ) {
              producttitlelist.push(data.title.toString());
            }
          });
        }
        if (producttitlelist.length >= 1) {
          let regex = new RegExp("^" + searchTerm, "i");
          //loop through words array
          for (let i in producttitlelist) {
            //check if input matches with any word in words array
            if (regex.test(producttitlelist[i]) && searchTerm != "") {
              //display suggestion
              suggestion.innerHTML = producttitlelist[i];
              break;
            } else {
              this.getSearchResults(searchTerm);
            }
          }
        } else {
          this.getSearchResults(searchTerm);
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getSearchResults(searchTerm) {
    $("#predictive-search").html("");
    fetch(
      `/search/suggest?q=${searchTerm}&resources[limit]=7&resources[limit_scope]=each&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
       
        this.predictiveSearchResults.innerHTML = resultsMarkup;
         checkcountry();
        this.open();
         $(".menuSearch_suggestions").hide(); 
         $(".productSearch_results").show(); 
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  autofilled() {
    var selsearchTerm = "";
    var oldparent = this;
    $(".suggrst").on("click", function () {
      $("#Searchproduct").val($(this).attr("data-text"));
      oldparent.getSearchResults($(this).attr("data-text"));
    });
    $(".chlikk").click(function () {
      oldparent.getSearchResults(
        oldparent.querySelector('input[type="search"]').value.trim()
      );
    });
  }
  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);

